import { FC } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { format } from "date-fns";

import { CardModelProps } from "./types";
import {
  selectDailyAverageModelLoadingState,
  selectDailyAverageModelScoresState,
  selectModelRangeValuesState,
  selectWeeklyModelScoresState,
} from "../../store/selectors/scores";
import { isModelAvailableForSubscriptionPlan } from "../../utils/isModelAvailableForSubscriptionPlan";
import { selectAuthSubscriptionPlan } from "../../store/selectors/auth";
import CardChartWithCalendar from "../CardChartWithCalendar";
import { ERoutes } from "../../constants/routes";
import { mapModelIcon, ModelIcons } from "../../types/models";

import styles from "./CardModel.module.css";



const CardModel: FC<CardModelProps> = ({
  item, 
  currentBrandId,
  onUpgrade,
}) =>   {
  const navigate = useNavigate();

  const dailyAverageModelLoading = useSelector(selectDailyAverageModelLoadingState);
  const weeklyScores = useSelector(selectWeeklyModelScoresState(Number(currentBrandId), Number(item.id)));
  const dailyAverageModelScores = useSelector(selectDailyAverageModelScoresState(Number(currentBrandId), Number(item.id)));
  const rangeValues = useSelector(selectModelRangeValuesState);
  const subscriptionPlan = useSelector(selectAuthSubscriptionPlan);
  const isProLocked =
    item.tier === "pro" && !isModelAvailableForSubscriptionPlan(item, subscriptionPlan);

  const handleDotClick = (created_at: string, modelId: string) => {
    const formattedDate = format(new Date(created_at), 'yyyy-MM-dd');
    navigate(ERoutes.ModelsDayly.replace(":id", String(currentBrandId)).replace(":date", formattedDate) + `#${modelId}`);
  }

  return (
    <CardChartWithCalendar
      item={item}
      type="model"
      customTitleClassName={styles["card-model__title"]}
      icon={mapModelIcon(item.name.toLowerCase() as ModelIcons)}
      currentBrandId={currentBrandId}
      dailyAverageLoading={dailyAverageModelLoading}
      dailyAverageScores={dailyAverageModelScores}
      rangeValues={rangeValues || undefined}
      weeklyScores={weeklyScores || undefined}
      weeklyScoresLoading={dailyAverageModelLoading}
      onDotClick={(created_at) => handleDotClick(created_at, item.id)}
      isProLocked={isProLocked}
      onUpgrade={onUpgrade}
    />
  );
};

export default CardModel;
